
import { useState } from 'react'
import { Form, Card, Row, Col} from 'antd';
import Footer from '../../../../../../components/common/Footer';
import PageHeading from '../../../../../../components/common/PageHeading';
import RightBar from '../../../../../../components/common/RightBar';
import FormAction from '../../../../../../components/common/FormAction';
import '../textingSetting.css';
import { PhoneOutlined } from '@ant-design/icons';
import { Select } from 'antd';

const { Option } = Select;

const TextingTab = () => {
    const [showEmail, setShowEmail] = useState(false)

    const onFinish = (values) => {
        console.log('Form values:', values);
    };

    const FirstCheckBoxValue = (e) => {
        setShowEmail(e.target.checked)
    }
    const GeneralSettingsRightBar = [];
    return (
        <div className='textingSetting'>
              
                    <Form layout='vertical'>
                        <PageHeading heading="Texting Settings" />

                        <Card className="cardBoxShadow" title="General Texting Settings" >

                            <label >
                                <input style={{ marginRight: '10px' }} type="checkbox"
                                    checked={showEmail}
                                    onChange={FirstCheckBoxValue}
                                />
                                Accept inbound text messages from tenants, owners, vendors, and prospects </label>

                            {showEmail && <Row style={{ marginLeft: '55px' }}>
                                <Col span={12} style={{ margin: '10px' }}>
                                    By default, email notifications will only be sent to the last person who texted that phone number.
                                </Col>
                                <Col style={{ margin: '10px' }}>
                                    Sometimes, texts can come in from phone numbers that nobody has texted before. To ensure these messages don’t get missed, you may designate email address to receive these messages.
                                </Col>

                            </Row>
                            }
                            {showEmail &&
                                <Row style={{
                                    marginTop: '10px', display: 'flex',
                                    alignItems: 'center'
                                }}>

                                    <Col span={8}>
                                        <label className='labelsEmail'>  Email:
                                        </label>
                                    </Col>
                                    <Col span={14} style={{
                                        display: 'flex'

                                    }}>
                                        <input
                                            className='inputEmail'
                                        >
                                        </input>
                                    </Col>

                                </Row>
                            }
                            <br></br>
                            <label>
                                <input style={{ marginRight: '10px' }} type="checkbox" />
                                Include co-signers on text messages and email communication by default when texting or emailing from the Resident's page.
                            </label>
                        </Card>

                        <Card className="cardBoxShadow" title="Inbound Call Forwarding Settings" style={{ margin: '10px 0px' }}>

                            <Row style={{
                                margin: '10px', display: 'flex', alignItems: 'center'


                            }}>                                <Col span={8}
                                style={{
                                    display: 'flex', justifyContent: 'end',
                                    alignItems: 'end'
                                }}


                            >
                                    <label
                                        className='labelsEmail'>
                                        Forward calls from tenants responding to system-generated texts to
                                        number:                                    </label>

                                </Col>
                                <Col span={14} style={{
                                    display: 'flex'

                                }}
                                >

                                    <Select
                                        suffixIcon={<PhoneOutlined />}
                                        defaultValue="Portfolio Phone Number"
                                        style={{
                                            width: 280, marginLeft: '10px',
                                        }}
                                    >
                                        <Option value="portfolio">Portfolio Phone Number</Option>
                                        <Option value="company">Company Phone Number (Default)</Option>
                                    </Select>
                                </Col>
                            </Row>
                            <Row>
                            </Row>
                        </Card>


                        <FormAction />

                    </Form>

                    <Footer />
              
          

            <div className="RightSidebar">
                <RightBar RightBarData={GeneralSettingsRightBar} />
            </div>

        </div>
    )
}

export default TextingTab